import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '../components/PageLayout';
import { MN2302220202_BasicReadAuthManager } from '../components/MN2302220202_BasicReadAuthManager';

/**
 * 시스템 관리 > 기본 조회 명단 관리
 * @constructor
 */
const MN2302220206Page = () => {
  const navigate = useNavigate();

  return (
    <PageLayout
      pageInfoBarCenterArea={<></>}
      pageInfoBarRightArea={<></>}
      enablePageInfoBarBackgroundColor={true}
    >
      <MN2302220202_BasicReadAuthManager
        id="MN2302220206"
        onClose={() => navigate(-1)}
      />
    </PageLayout>
  );
};

export default MN2302220206Page;
